import '../../styles/routes/home.css';
// Assumindo que comboCardData.js está em src/routes/data/comboCardData.js
// ou ajuste o caminho se for diferente. Se estiver em src/data/ComboCardData.js
// e Home.js está em src/routes/Home.js, o caminho seria '../data/comboCardData.js'
import mockComboCardData from './data/comboCardData.js'; // Verifique este caminho!
import AppleStore from '../../assets/icons/Apple_store.svg';
import PlayStore from '../../assets/icons/Play_store.svg';
import Flecha from '../../assets/icons/Flecha.svg';
import appDownloadCard_1 from '../../assets/images/appDownloadImage_1.png';
import { getIcon } from '../../utils/iconUtils.js';
//import { FaCheck } from "react-icons/fa";
import nettri_icon_app from '../../assets/images/nettri_icon_app.png';
import Nettri_logo_hero from '../../assets/images/Nettri_logo_hero.png';

// Imagens dos combos importadas
import comboImg1 from '../../assets/images/Combocard/combo1.png';
import comboImg2 from '../../assets/images/Combocard/combo2.png';
import comboImg3 from '../../assets/images/Combocard/combo3.png';
import comboImg4 from '../../assets/images/Combocard/combo4.png';
// Se tiver mais imagens únicas (combo5.png, etc.), importe-as também.


function Home() {

    // 1. Crie o mapa de imagens
    // As CHAVES neste objeto DEVEM CORRESPONDER EXATAMENTE às strings `imagem`
    // no seu arquivo comboCardData.js.
    const imageMap = {
        "../../assets/images/Combocard/combo1.png": comboImg1,
        "../../assets/images/Combocard/combo2.png": comboImg2,
        "../../assets/images/Combocard/combo3.png": comboImg3,
        "../../assets/images/Combocard/combo4.png": comboImg4,
        // Adicione mais mapeamentos se tiver outras imagens com caminhos diferentes
        // Por exemplo, se você tivesse um "combo5.png":
        // "../../assets/images/Combocard/combo5.png": comboImg5, (lembre-se de importar comboImg5)
    };

    const renderTags = (tags) => {
        return tags.map((tag, tagIndex) => {
            const Icon = getIcon(tag.icone, 'comboIcon');
            return (
                <div key={tagIndex} className="Combos-Tags">
                    <Icon />
                    <p>{tag.texto}</p>
                </div>
            );
        });
    };

    const storeApp = "https://onelink.to/qrcp63";

    const mockAboutData = {
        beneficios: {
            titulo: "Benefícios",
            data: [
                { descricao: "Benefício 1" },
                { descricao: "Benefício 2" },
                { descricao: "Benefício 3" },
            ],
        },
        aplicativos: {
            data: [
                { descricao: "Com o aplicativo da Net Tri você tem as soluções rápidas e simples." },
                { descricao: "Pague a fatura diretamente no app sem complicações." },
                { descricao: "Facilite sua vida com nossos aplicativo" },
            ],
        },
    };

    return (
        <div className='Home'>
            <section className='Hero'>
                <div className="hero__text-container" style={{ background: 'linear-gradient(357deg, #02094F -9724.61%, #040E89 -138.91%)' }} >
                    <div className="hero__text__left">
                        <div>
                            <span>Você se</span>
                        </div>
                        <div>
                            <span style={{ backgroundColor: '#D60036', color: '#fff', padding: '0 8px', borderRadius: '4px' }}>conecta</span>
                        </div>
                        <div>
                            <span>aqui.</span>
                        </div>
                    </div>
                    <div className='hero__right'>
                        <img src={Nettri_logo_hero} alt="Nettri Logo" className='hero__logo' />
                        <p className="hero__text__right">
                            Pronto para uma <span style={{ fontWeight: 900 }}>experiência fantástica</span> com a nossa conexão?
                        </p>
                        {/*
                                                <a href="#combosCards" className="hero__cta-btn">
                            <span style={{
                                background: '#D60036',
                                color: '#fff',
                                padding: '8px 24px',
                                borderRadius: '999px',
                                fontWeight: 700,
                                fontSize: '20px',
                                marginTop: '24px',
                                display: 'inline-block',
                                textDecoration: 'none'
                            }}>
                                CONHEÇA NOSSOS PLANOS <span style={{ fontSize: '22px', verticalAlign: 'middle' }}>⬇️</span>
                            </span>
                        </a>
                        
                        */}

                    </div>
                </div>
            </section>
            <section className="combosCards" id="combosCards">
                {/* Verifica se mockComboCardData e mockComboCardData[0].combos existem antes de mapear */}
                {mockComboCardData && mockComboCardData.length > 0 && mockComboCardData[0].combos && mockComboCardData[0].combos.map((combo, index) => {
                    const ribbon = combo.faixa ? <div className="Ribbon">MAIS VENDIDO!</div> : null;

                    // 2. Use o imageMap para obter a imagem correta
                    const imagemDoCombo = imageMap[combo.imagem];

                    if (!imagemDoCombo) {
                        console.warn(`Imagem não encontrada no imageMap para: ${combo.imagem}. Verifique o caminho no comboCardData.js e as importações/imageMap no Home.js.`);
                        // Você pode definir uma imagem padrão aqui se desejar:
                        // imagemDoCombo = 'url_para_imagem_padrao.jpg';
                    }

                    return (
                        <div
                            key={combo._id || `combo-${index}`} // Use combo._id se disponível, senão um fallback
                            className={`comboItem comboItem${index + 1}`}
                            // Use a variável imagemDoCombo (que contém a imagem importada)
                            style={{ backgroundImage: `url(${imagemDoCombo || ''})` }} // Adiciona fallback para string vazia se imagemDoCombo for undefined
                        >
                            <div className="Combos-CardFront">
                                <div className="Combos-CardBody">
                                    <strong><p className='Combos-Title'>{combo.titulo}</p></strong>
                                    <p className="Combos-Desc">{combo.descricao}</p>
                                    <p className="Combos-Botao1">
                                        <img src={Flecha} alt=" " />
                                        {combo.botoes.primeiro}
                                    </p>
                                </div>
                                {ribbon}
                            </div>
                            <div className="Combos-CardBack">
                                <div className="Combos-BackBody">
                                    <div className="Combos-Texts">
                                        <strong><p>{combo.titulo}</p></strong>
                                        <div className="Combos-Decorative-line"></div>
                                        <p className="Combos-Benefits">Benefícios Inclusos:</p>
                                    </div>
                                    <div className="Tags-Container">
                                        {renderTags(combo.tags)}
                                    </div>
                                    <div className="Combos-Conjunto">
                                        <div className="Combos-valor">
                                            <p className="Combos-RS">R$</p>
                                            <p className="Combos-Price">{combo.valor}</p>
                                        </div>
                                        <div className="Combos-Botao2">
                                            <a href={combo.botoes.link} target="_blank" rel="noopener noreferrer">
                                                <button>{combo.botoes.segundo}</button>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                {ribbon} {/* Você pode querer o ribbon apenas no front ou em ambos */}
                            </div>
                        </div>
                    );
                })}
            </section>

            <hr className='banner' />
            <section className='appDownload'>
                <div className='AppContainer'>
                    <div className="appDownload__text">
                        <h2 className="appDownload__title">Instale nosso app:</h2>
                        <ul className="appDownload__list">
                            {mockAboutData.aplicativos.data.map((app, index) => (
                                <li key={index} className="appDownload__list-item">
                                    <img className='appDownload__list-icon' src={nettri_icon_app} alt="Icone" />
                                    <span className='appDownload__list-text'>{app.descricao}</span>
                                </li>
                            ))}
                        </ul>
                        <div className='appDownload_store'>
                            <div className="appDownload__qr">
                                <img
                                    src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(storeApp)}`}
                                    alt="QR Code para baixar o app"
                                    className="appDownload__qr--code"
                                />
                            </div>
                            <div className='appDownload__storeLinks'>
                                <div className='appDownload__storeItem'>
                                    <a className='appDownload__storeLink' href={storeApp} target="_blank" rel="noopener noreferrer">Baixe na Play Store:<img src={PlayStore} alt="Play Store" /></a>
                                </div>
                                <div className='appDownload__storeItem'>
                                    <a className='appDownload__storeLink' href={storeApp} target="_blank" rel="noopener noreferrer">Download na Apple Store:<img src={AppleStore} alt="Apple Store" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='appDownload__image'>
                        <img className='appDownload__image--Card' src={appDownloadCard_1} alt="Instalar aplicativo" />
                    </div>
                </div>
            </section>
        </div >
    );
}

export default Home;